import './upload-image-failure-dialog.scss'

import { defineComponent, PropType } from 'vue';
import { BModal } from 'bootstrap-vue';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { CANCEL_ALL_IMAGE_UPLOAD, CANCEL_IMAGE_UPLOAD, RETRY_ALL_IMAGE_UPLOAD, RETRY_IMAGE_UPLOAD } from '../../events';

export interface FailedImageUpload {
    mediaUrl: string,
    cacheKey: string,
    info?: string,
    currentlyUploading?: boolean,
}

export const UploadImageFailureDialog = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        failedImageUploads: {
            type: Array as PropType<FailedImageUpload[]>,
            required: true,
        },
        title: {
            type: String,
            default: "uploadImageFailureDialog.title",
        },
        description: {
            type: String,
            default: "uploadImageFailureDialog.description",
        }
    },
    template: require('./upload-image-failure-dialog.html'),
    data() {
        return {
            currentSlideIndex: 0,
            loadingIcon: faCircleNotch,
        }
    },
    computed: {
        someImageCurrentlyUploading(): boolean {
            return this.failedImageUploads.findIndex(failedUpload => {
                return failedUpload.currentlyUploading
            }) > -1
        },
        computedDescription(): string {
            return (this.$t(this.description as string, [this.failedImageUploads.length]) ?? this.description) as string
        },
    },
    methods: {
        isUploading(index: number): boolean {
            return this.failedImageUploads?.[index]?.currentlyUploading ?? false
        },
        onActiveSlideChanged(index: number) {
            this.currentSlideIndex = index
        },
        onRetryAll() {
            this.$emit(RETRY_ALL_IMAGE_UPLOAD)
        },
        onCancelAll() {
            this.$emit(CANCEL_ALL_IMAGE_UPLOAD)
        },
        onRetry(index: number) {
            this.$emit(RETRY_IMAGE_UPLOAD, index)
        },
        onCancel(index: number) {
            this.$emit(CANCEL_IMAGE_UPLOAD, index)
        },
        closeModal() {
            (this.$refs.modal as BModal).hide()
        },
        openModal() {
            (this.$refs.modal as BModal).show()
        },
    },
    watch: {
        // keeps currentSlideIndex in range when the last image is removed (cancel or successful retry)
        failedImageUploads() {
            if(this.failedImageUploads.length && this.currentSlideIndex >= this.failedImageUploads.length) {
                this.currentSlideIndex = this.failedImageUploads.length - 1
            }
        },
    },
})
